// @flow

import React from 'react'
import type { Node as ReactNode } from 'react'
import cn from 'classnames'
import styles from './SortButton.css'

type SortButtonProps = {
  sorts: Array<Object>,
  activeSort: Object,
  initialText: string,
  text: ?string,
  handleChange: Function
}

const SortButton = ({
  sorts,
  activeSort,
  handleChange,
  initialText,
  text
}: SortButtonProps): ReactNode => {
  if (!sorts.length && initialText) {
    return (
      <div className={styles.sortBtn}>
        <p className={styles.sortBtnHeading}>{initialText}</p>
      </div>
    )
  } else if (!sorts.length) {
    return null
  }
  return (
    <form className={styles.sortBtn}>
      <fieldset className={styles.sortBtnFieldset}>
        {text && <legend className={styles.sortBtnHeading}>{text}</legend>}
        <div className={styles.sortBtnRadioWrapper}>
          {sorts.map(sort => {
            return (
              <label
                key={sort.type + sort.text}
                htmlFor={sort.type + sort.text}
                className={cn(styles.sortBtnLabel, {
                  [styles.sortBtnLabelChecked]: sort.type === activeSort.type
                })}
              >
                <input
                  type="radio"
                  value={sort.type}
                  id={sort.type + sort.text}
                  onChange={handleChange}
                  checked={sort.type === activeSort.type}
                  className={cn(styles.sortBtnRadio)}
                />
                <span className={styles.sortBtnFocusSpan} />
                <span className={styles.sortBtnLabelText}>{sort.text}</span>
              </label>
            )
          })}
        </div>
      </fieldset>
    </form>
  )
}

export default SortButton



// WEBPACK FOOTER //
// ./src/shared/components/SortBar/SortButton/SortButton.js